import React, { useState } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import AvitoStats from './Avitometrics';
import s from './styles/avitoStats.module.css';

const AvitoStatsContainer = ({ project }) => {
  const [blockKeys, setBlockKeys] = useState([Date.now()]);

  const handleAddBlock = () => {
    if (blockKeys.length < 3) {
      setBlockKeys([...blockKeys, Date.now()]);
    }
  };

  const handleRemoveBlock = (keyToRemove) => {
    setBlockKeys(blockKeys.filter((key) => key !== keyToRemove));
  };

  return (
    <div className={s.AvitoStatsContainer_div}>
      {blockKeys.map((key, index) => (
        <div key={key} className={s.blockWrapper}>
          <AvitoStats projectId={project.id} />
          {index > 0 && (
            <button
              className={s.closeButton}
              onClick={() => handleRemoveBlock(key)}
              title="Закрыть блок"
            >
              <FaTimes />
            </button>
          )}
        </div>
      ))}

      {blockKeys.length < 3 && (
        <button className={s.addButton} onClick={handleAddBlock}>
          <FaPlus /> <span>Сравнить</span>
        </button>
      )}
    </div>
  );
};

export default AvitoStatsContainer;
